import { useDatasetTriggerDispatches } from "@/shared/domain/triggers/hooks";

import { TriggerDispatchesTable } from "./TriggerDispatchesTable";

/** Every dispatch whose subject is this dataset, across all triggers, newest first. */
export function TriggerDispatchesForDataset({
  datasetId,
}: {
  datasetId: string;
}) {
  const query = useDatasetTriggerDispatches(datasetId);
  return (
    <TriggerDispatchesTable
      query={query}
      showTriggerColumn
      emptyMessage="No trigger activity for this dataset yet. When a trigger fires on this dataset's events, each dispatched target appears here."
    />
  );
}
